import styled from 'styled-components';

import { Button } from '@libs/components';

export const AssetContainer = styled.div`
  padding: 1.6rem 0;
  display: flex;

  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ChangeButton = styled(Button)`
  padding: 0 1rem;
  width: unset;
`;

export const AssetIcon = styled.img`
  width: 2.4rem;
  height: 2.4rem;
  margin-right: 0.4rem;
`;

export const AssetRows = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0.4rem;
`;
